(function ($) {
  $(document).ready(function () {
    if ($('.ssw-instagram-section').length) {
      var clickLoadmore = true;
      var count = 0;
      myInterval = setInterval(function () {
        count++;
        if (count > 200000) {
          clearInterval(myInterval)
        } else if ($('.ssw-instagram-section .ssw-instagram-items .ssw-instagram-item').length && $('.ssw-instagram-section .ssw-instagram-load-more a').length) {
          if (clickLoadmore) {
            setTimeout(function () {
              $('.ssw-instagram-section .ssw-instagram-load-more a').click();
            }, 100)
          }
          clickLoadmore = false;
          if ($('.ssw-instagram-section .ssw-instagram-items .ssw-instagram-item').length > 5) {
            $( ".ssw-instagram-section .ssw-instagram-items" ).clone().appendTo( ".ssw-instagram-section .ssw-instagram-grid" );
            $( ".ssw-instagram-section .ssw-instagram-items" ).clone().appendTo( ".ssw-instagram-section .ssw-instagram-grid" );
            $( ".ssw-instagram-section .ssw-instagram-items a img" ).each(function () {
              $(this).attr('src', $(this).data('low-src'));
            })
            clearInterval(myInterval);
          }
        }
      }, 30);
    }

    const trigger = new ScrollTrigger.default({
      scroll: {
        sustain: 50,
        stop: () => {
          if ($(window).scrollTop() == 0) {
            $('body').addClass('onTop').css('background', $('[data-background-color]').first().attr('data-background-color'));
          } else if ($('body').hasClass('onTop')) {
            $('body').removeClass('onTop').css('background', $('.shopify-section.in').find('[data-background-color]').attr('data-background-color'));
          }
        }
      }
    });
    trigger.add('.shopify-section', {
      once: false,
      offset: {
        viewport: {
          y: 0.5
        }
      },
      toggle: {
        class: {
          in: 'in',
          out: 'out'
        },
        callback: {
          in: (trigger) => {
            if ($(trigger.element).find('[data-background-color]').length) {
              $('body').css('background', $(trigger.element).find('[data-background-color]').attr('data-background-color'));
            }
          }
        }
      }
    });


    $('.mobile-submenu__list .back-main-menu').click(function () {
      $(this).closest('[data-mobile-menu-has-toggle="true"]').find('.submenu__label').click();
      return false;
    });
    
    $('.submenu__label .close-dropdown').click(function () {
      $(this).parents('.mobile-menu').toggleClass('mobile-menu-oveflow');
    });
    $('.menu__heading.back-main-menu').click(function () {
      $(this).parents('.mobile-menu').toggleClass('mobile-menu-oveflow');
    });

    $('.the-soak .wraper .items').owlCarousel({
      loop:true,
      margin:0,
      nav:true,
      navText: ['<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-left"><path d="M7.57129 1.60034C7.37955 1.60046 7.18785 1.67823 7.04199 1.83472L1.79199 7.4353C1.49902 7.74784 1.499 8.25364 1.79199 8.56616L7.04199 14.1658C7.33496 14.4781 7.80861 14.4781 8.10156 14.1658C8.39456 13.8532 8.39456 13.3474 8.10156 13.0349L4.12891 8.79663H13.1777C13.6061 8.79519 14 8.54062 14 8.02026C13.9999 7.50003 13.5968 7.24976 13.2002 7.24976H4.08691L8.10156 2.96558C8.39456 2.65304 8.39456 2.14725 8.10156 1.83472C7.95559 1.67808 7.76319 1.60034 7.57129 1.60034Z" fill="#383838"></path></svg>', '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon icon-chevron-right"><path d="M7.75 1.60034C7.94174 1.60046 8.13344 1.67823 8.2793 1.83472L13.5293 7.4353C13.8223 7.74784 13.8223 8.25364 13.5293 8.56616L8.2793 14.1658C7.98632 14.4781 7.51268 14.4781 7.21973 14.1658C6.92673 13.8532 6.92673 13.3474 7.21973 13.0349L11.1924 8.79663H2.14355C1.71516 8.79519 1.32132 8.54062 1.32129 8.02026C1.32134 7.50002 1.72446 7.24976 2.12109 7.24976H11.2344L7.21973 2.96558C6.92673 2.65304 6.92673 2.14725 7.21973 1.83472C7.3657 1.67807 7.5581 1.60034 7.75 1.60034Z" fill="#383838"></path></svg>'],
      dots: false,
      autoWidth: false,
      responsive:{
        0:{
          items:1
        },
        320:{
          items: 2
        },
        1000:{
          items:3
        }
      },
      onInitialized: function() {
        // Force recalculation after init
        setTimeout(function() {
          $('.the-soak .wraper .items').trigger('refresh.owl.carousel');
        }, 200);
      }
    })

    HeaderFixed();
    
    if($('section.our-favourites .product-wrap .product-thumbnail__title').length > 0){
      $('section.our-favourites .product-wrap .product-thumbnail__title').matchHeight();
    }
    if($('section.our-favourites .product-wrap p.type-product').length > 0){
      $('section.our-favourites .product-wrap p.type-product').matchHeight();
    }
    if($('section.our-favourites .featured-collection .product-wrap .thumbnail__caption .product-thumbnail').length > 0){
      $('section.our-favourites .featured-collection .product-wrap .thumbnail__caption .product-thumbnail').matchHeight();
    }
       
    
    // Hoding popup
    $('.page-content.holding-popup .box-popup .close-popup').click(function () {
      $('.page-content.holding-popup').removeClass('active');
    });

    setTimeout(function() { 
      $('.page-content.holding-popup').addClass('active');
    }, 100);
    $('.icon-popup-follow-us').click(function () {
      setTimeout(function() { 
        $('.page-content.holding-popup').toggleClass('active');
      }, 500);
    });

    $('.ssw-review-count').click(function(){
      console.log('111111');
    });
  });
  
  $(window).on('resize', function(){
    HeaderFixed();
    setVideoHeight();
  });
  $(window).on('orientationchange', function(){
    HeaderFixed();
    setVideoHeight();
  });
  $(window).on('load',function(){
    HeaderFixed();
    setVideoHeight();
  });
  
  $(window).scroll(function() {
    HeaderFixed();
    setVideoHeight();
  });

  
  function HeaderFixed() {
    var heightAnnouncementBar = 0;
    if($('.announcement-bar').length>0){
      heightAnnouncementBar = $('.announcement-bar').outerHeight();
    }
    var windowScrollTop = $(window).scrollTop();
    var heightHeader = $('header#header').outerHeight();
    $('.mega-menu').css("top", heightHeader + heightAnnouncementBar - windowScrollTop);
    
    var headerTop = $('header#header').offset().top;
    if(windowScrollTop > heightAnnouncementBar) {
      $('.mega-menu').css("top", heightHeader);
    }
  }
  

  function setVideoHeight() {
    // var video_w = $('section.section-product .media .box video');
    // var videoRatio = 1.77;
    // var windowRatio = 1.6; //this is width to height ratio of video.
    // windowRatio = $(window).width() / $(window).height();
    // video_w.addClass('resized');
    // if (windowRatio < videoRatio) {
    //   video_w.width($(window).width());
    //   video_w.height(video_w.width() / videoRatio);
    // }
    // else {
    //   video_w.height($(window).height());
    //   video_w.width(video_w.height().videoRatio);
    // }
  }
  

})(jQuery);